import { render, staticRenderFns } from "./nutritionDetail.vue?vue&type=template&id=51477e76&scoped=true"
import script from "./nutritionDetail.vue?vue&type=script&lang=js"
export * from "./nutritionDetail.vue?vue&type=script&lang=js"
import style0 from "./nutritionDetail.vue?vue&type=style&index=0&id=51477e76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51477e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51477e76')) {
      api.createRecord('51477e76', component.options)
    } else {
      api.reload('51477e76', component.options)
    }
    module.hot.accept("./nutritionDetail.vue?vue&type=template&id=51477e76&scoped=true", function () {
      api.rerender('51477e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/manage/nutritionDetail.vue"
export default component.exports